module.exports = __webpack_public_path__ + "img/login_bg.e06dc693.png";